import Vue from 'vue';
import Vuex from 'vuex';

import { store } from '@swipekit/lib/store';
import { Loader } from '@googlemaps/js-api-loader';
import posthog from 'posthog-js';
import { extractFirstTouch, hasExclusionCookie, identifyUser, isBotBrowser } from '@swipekit/lib/posthog.js';

if (window) {
	window.posthog = posthog;
}

Vue.use(Vuex);

export default new Vuex.Store({
	//plugins: [createLogger()],
	state: {
		extensionId: 'gojmmkhaiojimnnjhhilmhjmhdbdagod',
		extensionActive: false,
		google: null,
	},
	getters: {
		extensionId: function (state) {
			return state.extensionId;
		},
		standalone: function (state) {
			return false;
		},
		extensionState: function (state) {
			return state.extensionActive;
		},
		google: function (state) {
			return state.google;
		},
	},
	mutations: {
		SET_GOOGLE: function (state, google) {
			state.google = google;
		},
	},
	actions: {
		async init(store) {
			let pie = null;

			store.dispatch('app/setProcessing', true);

			store.dispatch('loadGoogleMaps');

			await store.dispatch('config/init');

			pie = await store.dispatch('users/init');

			await Promise.all([
				store.dispatch('users/hideCrisp'),
				store.dispatch('app/init'),
				store.dispatch('workspaces/init'),
				store.dispatch('folders/init'),
				store.dispatch('boards/init'),
				store.dispatch('ads/init'),
				store.dispatch('comments/init'),
				store.dispatch('events/init'),
				store.dispatch('message/init'),
				store.dispatch('brands/init'),
				store.dispatch('briefs/init'),
			]);

			// ---

			if (store.rootGetters['users/isAuth']) {
				if (!pie) {
					pie = await store.dispatch('users/getPie');
				}

				await store.dispatch('afterLogin', pie);

				const env = process.env.VUE_APP_NODE_ENV || process.env.NODE_ENV || 'development';
				const excluded = hasExclusionCookie(document.cookie) || isBotBrowser(navigator);

				if (env === 'production' && window.location.hostname !== 'localhost' && !excluded) {
					posthog.init('phc_i5JrVN3GGrKMmJ1CnvfgGEtcZVq2uUonJu8MpiLiaE4', {
						api_host: 'https://a.swipekit.app',
						persistence: 'cookie',
						cross_subdomain_cookie: true,
						capture_pageview: false,
						enable_recording_console_log: false,
						autocapture: false,
						loaded: () => {
							const identified = identifyUser(
								posthog,
								store.getters['users/user'],
								store.getters['workspaces/all'],
								document,
								window.location
							);
							if (!identified) {
								return;
							}

							const firstTouch = extractFirstTouch(window.location.href, document.referrer, window.affonso_referral || '');
							posthog.setPersonProperties({}, firstTouch);
							posthog.capture('$pageview', {
								$current_url: window.location.href,
								$pathname: window.location.pathname,
							});
						},
					});
				}
			}

			// let data = await store.dispatch("boards/getBoardData", {
			//   id: "client_jdstride-df50bdd1-board",
			//   action: "get-board-data",
			// });
			// console.log(data);

			if (store.getters.standalone) {
				await store.dispatch('boards/getBoardData');
			}

			store.dispatch('app/setProcessing', false);
			await store.dispatch('app/setInit'); // <!-- Very Important, app literally loads after this dispatch

			await store.dispatch('triggerExtension', { type: 'boards:update' });

			let workspace = store.getters['workspaces/all'];

			if (workspace && !workspace.activated) {
				await store.dispatch('app/promptEmailActivation');
			}

			return true;
		},

		async loadGoogleMaps(store) {
			const loader = new Loader({
				apiKey: `AIzaSyCLVWTK25PuHu9ezeXJIekKMY85EwF09FY`,
				libraries: ['places'],
			});

			let google = await loader.load().catch((err) => {
				console.log('GOOGLE MAPS ERROR');
				console.log(err);
			});

			store.commit('SET_GOOGLE', google);
		},

		async afterLogin(store, pie) {
			await Promise.all([
				await store.dispatch('app/afterLogin', pie),
				await store.dispatch('workspaces/afterLogin', pie),
				await store.dispatch('folders/afterLogin', pie),
				await store.dispatch('boards/afterLogin', pie),
				await store.dispatch('ads/afterLogin', pie),
				await store.dispatch('comments/afterLogin', pie),
				await store.dispatch('brands/afterLogin', pie),
				await store.dispatch('briefs/afterLogin', pie),
			]);

			await store.dispatch('users/showCrisp');

			return true;
		},

		async afterLogout(store) {
			await store.dispatch('workspaces/afterLogout');
			await store.dispatch('folders/afterLogin');
			await store.dispatch('boards/afterLogout');
			await store.dispatch('ads/afterLogout');
			await store.dispatch('comments/afterLogout');
			await store.dispatch('users/afterLogout');
			await store.dispatch('brands/afterLogout');
			await store.dispatch('briefs/afterLogout');

			return true;
		},

		async triggerExtension(store, obj) {
			if (typeof chrome === 'undefined') {
				return;
			}
			if (!chrome) {
				return;
			}
			if (!chrome.runtime) {
				return;
			}

			chrome.runtime.sendMessage(
				store.state.extensionId,
				obj,
				function (response) {
					//resolve(response);
				}
			);

			return;
		},

		async setExtensionState(store, condition) {
			store.state.extensionActive = condition;
		},
	},
	modules: {
		config: store.config,
		app: store.app,
		ads: store.ads,
		folders: store.folders,
		boards: store.boards,
		users: store.users,
		workspaces: store.workspaces,
		comments: store.comments,
		events: store.events,
		message: store.message,
		brands: store.brands,
		briefs: store.briefs,
	},
});
